import React, { useContext, useEffect } from 'react';
import { shape, bool } from 'prop-types';
import Button from '@mui/material/Button';
import AddLocationTwoToneIcon from '@mui/icons-material/AddLocationTwoTone';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import './zipcodeform.scss';
import variables from '../../../../global/assets/_variables.scss';
import InputBox from '../../../inputbox/InputBox';
import { StoreHeaderDataContext } from '../../../../context-api/StoreHeaderDataProvider';
import { NO_KITCHEN_FOUND_MSG_FOR_CUSTOMER, localStorageKeys } from '../../../../global/constants';
import { removeParamFromUrl } from '../../../../global/getUrl';

const { ZIP_CODE } = localStorageKeys;

const zipCodeValidator = (zip) => /^[0-9]{5}$/.test(zip);

const ZipCodeForm = (props) => {
  const {
    buttonStyleProp,
    zipCodeFormContainerStyle,
    inputStyles,
    sigupForm = false,
    disableAlert,
    autoFocus,
    disableLabel,
    buttonLabel,
    buttonBackground,
    zipCodeErrorMsg,
    size,
    mandatoryError = false,
  } = props;
  const dataContext = useContext(StoreHeaderDataContext);
  const {
    kitchensByZipcode,
    onGetKitchenByZipcode,
    setKitchensByZipcode,
    clearZipcodeFromLocalStorage,
    zipcode,
    setZipcode,
  } = dataContext;
  const { zipcode: localStorageZipcode, error, loading, success } = kitchensByZipcode;

  useEffect(() => {
    const currentLocalStorageZipcode = localStorage?.getItem(ZIP_CODE);
    if (currentLocalStorageZipcode) {
      setKitchensByZipcode({ ...kitchensByZipcode, zipcode: localStorage?.getItem(ZIP_CODE) });
    }
    return () => {
      //clear the zipcode value in context API
      setZipcode('');
    };
  }, [localStorage?.getItem(ZIP_CODE)]);

  const zipCodeHandler = (e) => {
    const { value } = e.target;
    if (value.length < 6 && value.trim() !== '') {
      setZipcode(value);
    } else if (value.length === 0) {
      setZipcode('');
    }
    setKitchensByZipcode({
      ...kitchensByZipcode,
      success: true,
      error: '',
      totalKitchens: 0,
    });
  };
  const isZipValid = zipCodeValidator(zipcode);
  const showZipError = !isZipValid;

  const onSubmitHandler = () => {
    if (isZipValid) {
      setZipcode(zipcode);
      onGetKitchenByZipcode(zipcode);
    }
  };

  const onBlurHandler = () => {
    if (isZipValid) {
      const setLocalStorage = true;
      onGetKitchenByZipcode(zipcode, setLocalStorage);
    }
  };

  const onChangeZipcode = () => {
    removeParamFromUrl('zipcode');
    removeParamFromUrl('promo');
    clearZipcodeFromLocalStorage();
    window.location.reload();
  };
  const apiError =
    error.length > 0 ? (
      <Alert id='alert-box' sx={{ border: 'none' }} severity='error'>
        Network error, Please try again!
      </Alert>
    ) : (
      ''
    );
  return (
    <div style={zipCodeFormContainerStyle} className='zipcode-form-container'>
      {disableLabel ||
        (!sigupForm && localStorageZipcode && (
          <div className='zipcode-label'>
            <span>
              <span className='zipcode-content'>Delivery to {localStorageZipcode}</span>
            </span>
            <Button color='primary' onClick={onChangeZipcode}>
              Remove
            </Button>
          </div>
        ))}
      {!disableAlert && apiError}
      {!disableAlert && !success && (zipCodeErrorMsg || zipcode) && (
        <Alert id='warning-box' severity='warning'>
          {zipCodeErrorMsg || `${NO_KITCHEN_FOUND_MSG_FOR_CUSTOMER} ${zipcode}`}
        </Alert>
      )}
      <div className='form' id='atomic-zipcode-input'>
        <InputBox
          autoFocus={autoFocus}
          type='number'
          label='Enter Zipcode'
          size={size || 'small'}
          width={'auto'}
          name='zipcode'
          onChange={zipCodeHandler}
          error={mandatoryError || (zipcode.length > 0 && showZipError)}
          inputErrorMsg={zipcode.length > 0 && showZipError ? 'Invalid Zip Entered' : ''}
          inputProps={{ maxLength: 5, pattern: 'd{1,6}' }}
          value={zipcode}
          sx={inputStyles}
          onBlur={sigupForm ? onBlurHandler : null}
          showLoader={sigupForm && loading}
        />
        {!sigupForm && (
          <Button
            disabled={!isZipValid || loading}
            variant='contained'
            size={size || 'small'}
            style={{
              minWidth: '105px',
              marginLeft: '10px',
              height: 'auto',
              background:
                !isZipValid || loading
                  ? variables.backgroundDisabled
                  : buttonBackground || variables.activeFontOrange,
              ...buttonStyleProp,
            }}
            startIcon={
              loading ? <CircularProgress size={15} color='inherit' /> : <AddLocationTwoToneIcon />
            }
            onClick={onSubmitHandler}
          >
            {buttonLabel || 'APPLY'}
          </Button>
        )}
      </div>
      {/* <>
        {!success && <span className="zip-code-form-error">{`Sorry we don't deliver to ${zipcode}`}</span>}
      </> */}
    </div>
  );
};

export default ZipCodeForm;

ZipCodeForm.propTypes = {
  buttonStyleProp: shape({}),
  zipCodeFormContainerStyle: shape({}),
  inputStyles: shape({}),
  // data: shape({}),
  loading: bool,
  success: bool,
  autoFocus: bool,
  disableLabel: bool,
};

ZipCodeForm.defaultProps = {
  buttonStyleProp: { width: 'fit-content', height: '40px' },
  zipCodeFormContainerStyle: {},
  inputStyles: {},
  // data: {},
  loading: false,
  success: false,
  disableAlert: false,
  autoFocus: true,
  disableLabel: false,
};
